import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-on-screen-keyboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './on-screen-keyboard.component.html',
  styleUrls: ['./on-screen-keyboard.component.scss']
})
export class OnScreenKeyboardComponent {
  @Input() mode: 'text' | 'rut' = 'text';
  @Input() value = '';
  @Input() placeholder = '';
  @Input() maxLength = 40;
  @Output() valueChange = new EventEmitter<string>();
  @Output() enter = new EventEmitter<void>();

  private readonly textRows = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ñ'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
  ];

  private readonly rutKeys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['K', '0', '⌫'],
  ];

  get rows(): string[][] {
    return this.mode === 'rut' ? this.rutKeys : this.textRows;
  }

  get displayValue(): string {
    if (this.mode === 'rut') {
      return this.formatRut(this.value);
    }
    return this.value;
  }

  pressKey(key: string): void {
    if (key === '⌫') {
      this.backspace();
      return;
    }

    if (this.mode === 'rut') {
      // Only allow digits and K, max 9 chars (without dash)
      const clean = this.value.replace(/[^0-9kK]/g, '');
      if (clean.length >= 9) return;
      if (key === 'K' && clean.length < 7) return; // K only at the end
      this.value = clean + key;
    } else {
      if (this.value.length >= this.maxLength) return;
      this.value += key;
    }
    this.valueChange.emit(this.value);
  }

  pressSpace(): void {
    if (this.mode !== 'text') return;
    if (this.value.length >= this.maxLength) return;
    this.value += ' ';
    this.valueChange.emit(this.value);
  }

  backspace(): void {
    if (this.value.length > 0) {
      this.value = this.value.slice(0, -1);
      this.valueChange.emit(this.value);
    }
  }

  pressEnter(): void {
    this.enter.emit();
  }

  private formatRut(rut: string): string {
    const clean = rut.replace(/[^0-9kK]/g, '');
    if (clean.length <= 1) return clean;
    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);

    // Add dots to body
    let formatted = '';
    const reversed = body.split('').reverse();
    for (let i = 0; i < reversed.length; i++) {
      if (i > 0 && i % 3 === 0) formatted = '.' + formatted;
      formatted = reversed[i] + formatted;
    }
    return formatted + '-' + dv.toUpperCase();
  }
}
